import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Group } from "@shared/models/group"
import type NotifierService from "cc-frontend/services/notifier"
import type Rpc from "cc-frontend/services/rpc"

interface Sig {
  Args: {
    model: Group
  }
}

export default class AdminSidebarGroupComponent extends Component<Sig> {
  @service declare notifier: NotifierService
  @service declare rpc: Rpc

  @tracked
  canShowActionMenu = false

  @computed("args.model.relationships.fiscalGroup.data")
  get hasFiscalGroup() {
    console.log(this.args.model.relationships.fiscalGroup)
    return !!this.args.model.relationships.fiscalGroup?.data
  }

  @action
  createFiscalGroup() {
    this.rpc.group_admin_create_fiscal_group({ groupId: this.args.model.id }).then((response) => {
      if (response.responseOk) {
        this.notifier.success("", {
          title: "Fiscal Group Created!",
          message: "Open it from the right sidebar.",
          duration: 3000,
        })
      } else {
        this.notifier.warning("", {
          title: `Error creating fiscal group`,
          message: "Refresh the page and see if it already exists.",
          duration: 5000,
          type: "is-processing",
        })
      }
    })

    this.canShowActionMenu = false
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Admin::Group::Sidebar": typeof AdminSidebarGroupComponent
  }
}
